<div>
  <mat-icon [inline]="true">report</mat-icon>
  <h1 i18n>This page doesn't exist</h1>
</div>
